/**
 * 建立 FontAwesome 图标库，供 index.tsx 和 test/setup.ts 直接引用
 * （以避免 test 中未引用图标报 Warning）
 */
import { library, IconDefinition } from '@fortawesome/fontawesome-svg-core';
import {
  faSyncAlt,
  faBars,
  faSearchMinus,
  faSearchPlus,
  faArrowsAltH,
  faArrowsAltV,
  faImage,
  faCaretUp,
  faCaretDown,
  faChevronLeft,
  faChevronUp,
  faChevronCircleUp,
  faChevronDown,
  faChevronCircleDown,
  faCog,
  faAngleDoubleRight,
  faRobot,
  faTimes,
  faWifi,
  faHome,
  faBook,
  faAngleLeft,
  faEllipsisH,
  faPlus,
  faBan,
  faCaretLeft,
  faCaretRight,
  faCheck,
  faExclamationTriangle,
  faAngleRight,
  faUserCircle,
  faSignOutAlt,
  faBox,
  faLayerGroup,
  faCheckDouble,
  faCommentAlt,
  faCloudUploadAlt,
  faExclamationCircle,
  faLanguage,
  faCloud,
  faExchangeAlt,
  faPenNib,
  faPencilAlt,
  faStar,
  faSpinner,
  faTag,
  faDownload,
  faSync,
  faThLarge,
  faThList,
  faAngleDoubleDown,
  faAngleDoubleUp,
  faUserCheck,
  faLink,
  faSave,
  faPaste,
} from '@fortawesome/free-solid-svg-icons';
import { faKissWinkHeart as faKissWinkHeartRegular } from '@fortawesome/free-regular-svg-icons';
import { faGithub } from '@fortawesome/free-brands-svg-icons';
// Reconstruct the names explicitly: icon packages and core use different
// common-types versions with different IconName unions.
const icons: IconDefinition[] = [
  { ...faSyncAlt, iconName: 'sync-alt' },
  { ...faBars, iconName: 'bars' },
  { ...faSearchMinus, iconName: 'search-minus' },
  { ...faSearchPlus, iconName: 'search-plus' },
  { ...faArrowsAltH, iconName: 'arrows-alt-h' },
  { ...faArrowsAltV, iconName: 'arrows-alt-v' },
  { ...faImage, iconName: 'image' },
  { ...faCaretUp, iconName: 'caret-up' },
  { ...faCaretDown, iconName: 'caret-down' },
  { ...faChevronUp, iconName: 'chevron-up' },
  { ...faChevronCircleUp, iconName: 'chevron-circle-up' },
  { ...faChevronDown, iconName: 'chevron-down' },
  { ...faChevronCircleDown, iconName: 'chevron-circle-down' },
  { ...faChevronLeft, iconName: 'chevron-left' },
  { ...faCog, iconName: 'cog' },
  { ...faAngleDoubleRight, iconName: 'angle-double-right' },
  { ...faRobot, iconName: 'robot' },
  { ...faTimes, iconName: 'times' },
  { ...faWifi, iconName: 'wifi' },
  { ...faHome, iconName: 'home' },
  { ...faBook, iconName: 'book' },
  { ...faAngleLeft, iconName: 'angle-left' },
  { ...faEllipsisH, iconName: 'ellipsis-h' },
  { ...faPlus, iconName: 'plus' },
  { ...faBan, iconName: 'ban' },
  { ...faCaretLeft, iconName: 'caret-left' },
  { ...faCaretRight, iconName: 'caret-right' },
  { ...faCheck, iconName: 'check' },
  { ...faExclamationTriangle, iconName: 'exclamation-triangle' },
  { ...faAngleRight, iconName: 'angle-right' },
  { ...faUserCircle, iconName: 'user-circle' },
  { ...faSignOutAlt, iconName: 'sign-out-alt' },
  { ...faBox, iconName: 'box' },
  { ...faLayerGroup, iconName: 'layer-group' },
  { ...faCheckDouble, iconName: 'check-double' },
  { ...faCommentAlt, iconName: 'comment-alt' },
  { ...faCloudUploadAlt, iconName: 'cloud-upload-alt' },
  { ...faExclamationCircle, iconName: 'exclamation-circle' },
  { ...faLanguage, iconName: 'language' },
  { ...faCloud, iconName: 'cloud' },
  { ...faExchangeAlt, iconName: 'exchange-alt' },
  { ...faPenNib, iconName: 'pen-nib' },
  { ...faPencilAlt, iconName: 'pencil-alt' },
  { ...faStar, iconName: 'star' },
  { ...faSpinner, iconName: 'spinner' },
  { ...faTag, iconName: 'tag' },
  { ...faDownload, iconName: 'download' },
  { ...faSync, iconName: 'sync' },
  { ...faThLarge, iconName: 'th-large' },
  { ...faThList, iconName: 'th-list' },
  { ...faAngleDoubleDown, iconName: 'angle-double-down' },
  { ...faAngleDoubleUp, iconName: 'angle-double-up' },
  { ...faUserCheck, iconName: 'user-check' },
  { ...faLink, iconName: 'link' },
  { ...faSave, iconName: 'save' },
  { ...faPaste, iconName: 'paste' },
  // Regular icons
  { ...faKissWinkHeartRegular, iconName: 'kiss-wink-heart' },
  // Brand icons
  { ...faGithub, iconName: 'github' },
];
library.add(...icons);
